import { useEffect, useRef } from 'react'
import { NavLink } from 'react-router-dom'
import { QUALITY_ROUTE, whenTestify } from '../lib/testify'

// The Quality Control item in the sidebar. An ordinary link to the board page; the widget only owns the
// red open-defect badge in the slot beside the label (Testify.mount — with page mode configured it wires
// no click of its own). ONE badge: nothing else in the shell counts open defects.

export function QualityNav() {
  const ref = useRef<HTMLAnchorElement>(null)
  useEffect(() => {
    let cancelled = false
    void whenTestify().then((api) => {
      if (!cancelled && api && ref.current) api.mount(ref.current)
    })
    return () => {
      cancelled = true
    }
  }, [])
  return (
    <div className="nav-section">
      <div className="nav-group">Quality</div>
      <NavLink ref={ref} to={QUALITY_ROUTE} className={({ isActive }) => (isActive ? 'nav-item quality-nav active' : 'nav-item quality-nav')}>
        Quality Control <span className="tfy-badge" />
      </NavLink>
    </div>
  )
}
